import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useLanguage } from '../../../../contexts/LanguageContext';
import translations from './IrreversibleActionModal.translations.json';

type SupportedLanguage = keyof typeof translations;
export type CandidateAction = 'validate' | 'pending' | 'reject' | 'offerSent' | 'contractSent' | 'hired';

interface IrreversibleActionModalProps {
  open: boolean;
  action: CandidateAction;
  onClose: () => void;
  onConfirm: () => void;
}

export const IrreversibleActionModal: React.FC<IrreversibleActionModalProps> = ({
  open,
  action,
  onClose,
  onConfirm,
}) => {
  const { language } = useLanguage();
  const content = translations[language as SupportedLanguage] || translations.en;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          backgroundColor: '#121316',
          color: '#FFFFFF',
          border: '1px solid #333742',
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: 'bold' }}>{content.title}</DialogTitle>
      <DialogContent>
        <Typography color="#C5C9D3">{content.message}</Typography>
        <Typography color="#F0AD4E" fontWeight="bold" mt={1.5}>
          {content.actionLabels[action]}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} sx={{ color: '#C5C9D3', textTransform: 'none' }}>
          {content.cancel}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          sx={{ fontWeight: 'bold', textTransform: 'none' }}
        >
          {content.confirm}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IrreversibleActionModal;
